import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=50922eac&scoped=true"
import script from "./ListTable.vue?vue&type=script&lang=js"
export * from "./ListTable.vue?vue&type=script&lang=js"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=50922eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50922eac",
  null
  
)

export default component.exports